export default __webpack_public_path__ + "static/media/curryboy.bdf5d223.jpg";